function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Utillity manager to help check values for e.g. null or empty
 * @memberOf module:wdh-feature-b2b
 */
var CheckUtils = /*#__PURE__*/function () {
  function CheckUtils() {
    _classCallCheck(this, CheckUtils);
  }
  return _createClass(CheckUtils, null, [{
    key: "isNullObject",
    value:
    /**
     * Check if an object is null
     * @param {Object} obj  Object to check
     * @returns {Bool}      True if object is null, else false
     */
    function isNullObject(obj) {
      return obj === undefined || obj === null;
    }

    /**
     * Check if an object is null or empty (has no keys)
     * @param {Object} obj  Object to check
     * @returns {Bool}      True if object is null or empty, else false
     */
  }, {
    key: "isNullOrEmptyObject",
    value: function isNullOrEmptyObject(obj) {
      var isNull = CheckUtils.isNullObject(obj);
      if (isNull === false) {
        var keys = Object.keys(obj);
        isNull = keys.length === 0;
      }
      return isNull;
    }

    /**
     * Check if an array is null or empty
     * @param {Object} arr  Array to check
     * @returns {Bool}      True if array is null or empty, else false
     */
  }, {
    key: "isNullOrEmptyArray",
    value: function isNullOrEmptyArray(arr) {
      return arr === undefined || arr === null || arr.length === 0;
    }

    /**
     * Check if a string is null or empty
     * @param {String} str  String to check
     * @returns {Bool}      True if string is null or empty, else false
     */
  }, {
    key: "isNullOrEmptyString",
    value: function isNullOrEmptyString(str) {
      return str === undefined || str === null || str === '';
    }

    /**
     * Check if a string is null or whitespace
     * @param {String} str  String to check
     * @returns {Bool}      True if string is null or whitespace, else false
     */
  }, {
    key: "isNullOrWhiteSpace",
    value: function isNullOrWhiteSpace(str) {
      return str === undefined || str === null || str.trim() === '';
    }

    /**
     * Check if a number is null or empty
     * @param {Number} number  String to check
     * @returns {Bool}         True if number is null or empty, else false
     */
  }, {
    key: "isNullOrEmptyNumber",
    value: function isNullOrEmptyNumber(number) {
      return number === undefined || number === null || Number.isNaN(number);
    }
  }]);
}();
export default CheckUtils;